export default __webpack_public_path__ + "static/media/purple_back.2c7696eb.png";